import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { GatsbyImage as Img } from 'gatsby-plugin-image'
import { Heading } from 'theme-ui'

const styles = {
  image: {
    verticalAlign: `middle`,
    maxWidth: 280,
    height: 35,
    img: {
      objectFit: "contain"
    }
  },
  grayscale: {
    WebkitFilter: `grayscale(1)`,
    filter: `grayscale(1)`,
    opacity: `0.7`
  },
  title: {
    m: 0,
    maxWidth: 280,
  }
}

const Logo = ({ title, grayscale, image, alt, to, sx, ...props }) => (
  <Heading
    as={Link}
    to={to}
    title={title}
    aria-label={title}
    variant='h2'
    sx={styles.title}
    {...props}
  >
    {image ? (
      <amp-img
        src={image.src}
        srcset={image.srcSet}
        layout="responsive"
        width={280}
        height={42}
        style={styles.image}
        alt={alt}
        {...props}
      />
    ) : (
      title
    )}
  </Heading>
)

export default Logo

Logo.defaultProps = {
  to: '/'
}

Logo.propTypes = {
  title: PropTypes.string,
  grayscale: PropTypes.bool,
  fixed: PropTypes.object, //gatsby-transform-sharp
  to: PropTypes.string
}
